// extracted by mini-css-extract-plugin
export var menuIcon = "_u6-0";
export var menuIconInline = "_u6-1";